import RestService from './RestService';

export default class Certificates extends RestService {
    constructor(parentService, parentId) {
        super(`${parentService.baseUrl}/${parentId}/certificate`);
    }
}
